import { render, staticRenderFns } from "./modalDeleteAnexo.vue?vue&type=template&id=3071955e"
import script from "./modalDeleteAnexo.vue?vue&type=script&lang=js"
export * from "./modalDeleteAnexo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports